import { createGlobalStyle } from 'styled-components';
import { navbarOpenHeight } from '@zopauk/react-components';

export const GlobalAppStyles = createGlobalStyle`
  *:not(h1,h1 > *,h2,h2 > *,h3,h3 > *,h4,h4 > *,.material-symbols-outlined,.font-serif) { font-family: var(--sans-font) !important; }

  h1, h2, h3, h4, h1 > *, h2 > *, h3 > *, h4 > * {
    font-family: var(--font-serif) !important;
    font-weight: 600 !important;
  }

  video {
    isolation: isolate;
  }

  html, body {
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }

  html.navigation-open {
    overflow: hidden;

    body {
      overflow: hidden;
    }
  }

  img {
    image-rendering: -webkit-optimize-contrast;
  }

  .clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  ul.unstyled-list {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

  .sr-only {
    border: 0;
    clip: rect(1px 1px 1px 1px);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  hr {
    border: 0;
    border-bottom: 1px solid #DADCE2;
    margin: 20px 0;
  }

  .display-linebreak {
    white-space: pre-line;
  }

  .blockquote {
    display: block;
    background: #E4F9F1;
    font-style: italic;
    padding: 20px 30px;
    margin-left: 0;
    border-left: 6px solid #71E6C0;
  }

  .zopa-modal-overlay {
      z-index: 100 !important;
  }

  #amazon-connect-chat-widget > div {
    z-index: 20 !important;
  }

  .main-content {
    min-height: calc(80vh - ${navbarOpenHeight}px);
    position: relative;
  }

  // Hide Google reCaptcha badge in the right corner
  .grecaptcha-badge {
      visibility: hidden;
      opacity: 0;
      position: absolute;
  }

  .accordion-overwrite h3 > button > div {
    background-color: #F1F1F7;
  }

  #onetrust-consent-sdk #onetrust-policy-text,
  #onetrust-consent-sdk #onetrust-pc-btn-handler,
  #onetrust-consent-sdk #onetrust-accept-btn-handler,
  #onetrust-banner-sdk #onetrust-reject-all-handler {
    font-family: 'Inter', 'Inter Fallback' !important;
  }

  #onetrust-consent-sdk #onetrust-pc-btn-handler {
    background-color: #FFFFFF !important;
    font-weight: 500 !important;
    border: 1px solid #387360 !important;
    color: #0E2C27 !important;
  }

  #onetrust-consent-sdk #onetrust-pc-btn-handler:hover {
    background-color: #F1F1F7 !important;
    border: 1px solid #387360 !important;
    color: #0E2C27 !important;
    opacity: 1 !important;
  }

  #onetrust-consent-sdk #onetrust-accept-btn-handler,
  #onetrust-banner-sdk #onetrust-reject-all-handler,
  body #onetrust-consent-sdk #onetrust-pc-sdk button:not(#clear-filters-handler):not(.ot-close-icon):not(#filter-btn-handler):not(.ot-remove-objection-handler):not(.ot-obj-leg-btn-handler):not([aria-expanded]):not(.ot-link-btn) {
    background: #0E2C27 !important;
    color: #71E6C0 !important;
    opacity: 1 !important;

    &:hover {
      background: #275749 !important;
      opacity: 1 !important;
    }
  }

  #onetrust-consent-sdk #onetrust-banner-sdk a[href] {
    color: #0E2C27 !important;
  }

  #onetrust-pc-sdk {
  font-family: 'Inter', 'Inter Fallback' !important;
  }
`;
